import { Pipe, PipeTransform } from '@angular/core';

/**
 * Copié d'Essentiel
 */
@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
    transform(val: string, args = null) {
        if (!val) {
            return '';
        }

        // const regexPhone =  /^(\+|00|0)?[1-9](\d ?){1,14}$/;
        val = val.replace(/[^\+0-9]/g, '');
        let prefix: string;
        let i = 0;

        if (val.charAt(0) !== '0') {
            prefix = val.substr(0, 3) + ' ' + val.charAt(3);
            i += 2;
        } else {
            prefix = '' + val.substr(0, 2);
            i += 1;
        }

        let newStr = ' ';
        for (; i < (Math.floor(val.length / 2) - 1); i++) {
            newStr = newStr + val.substr(i * 2, 2) + ' ';
        }
        return prefix + newStr + val.substr(i * 2);
    }
}
